import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendApiService } from "./backend-api.service";

@Injectable({
  providedIn: 'root',
})
export class SlotReleaseCalendarService {

  constructor(private backendApiService: BackendApiService) {}

  getUpcomingGames(params: any = {}): Observable<any> {
    return this.backendApiService.get('/games/upcoming', params);
  }

  findUpcomingGameByName(name: string): Observable<any> {
    return this.backendApiService.get('/games/upcoming/match', { name });
  }

  importUpcomingGames(params: any = {}): Observable<any> {
    return this.backendApiService.post('/games/upcoming/import', params);
  }
}